export var FeedType;
(function (FeedType) {
    FeedType["USER_TIMELINE"] = "user_timeline";
    FeedType["USER_TIMELINE_HASHTAG"] = "user_timeline_hashtag";
    FeedType["PLAYLIST"] = "playlist";
    FeedType["PRODUCT_SKU"] = "product_skus";
    FeedType["PLAYLIST_COLLECTION"] = "playlist_collection";
    FeedType["SHOWROOM_SCHEDULE"] = "showroom_schedule";
})(FeedType || (FeedType = {}));
